import { EntityBase } from "./EntityBase";
import { AlertType } from "./AlertType";
import { AlertTypeOption } from "./AlertTypeOption";
import { User } from "./User";

export class AlertSubscription extends EntityBase {
    user: User = null!;
    alertType: AlertType|null = null;
    alertOption: AlertTypeOption|null = null;
}
